import * as React from 'react';
import css from './TTImportWizard.module.css';

interface TTImportMappingStepProps {
  importHeader: string[];
  importSamples: number;
  importRows: any[];
  setImportStep: (v: number) => void;
}

export function TTImportMappingStep({
  importHeader,
  importSamples,
  importRows,
  setImportStep,
}: TTImportMappingStepProps): React.JSX.Element {
  return (
    <div className={css.mappingBlock}>
      <div className={css.mappingTitle}>Detected columns</div>
      <div className={css.mappingHeader}>Header: {importHeader.join(' | ')}</div>
      <div className={css.mappingSamples}>
        Samples: {importSamples} &middot; Rows: {importRows.length}
      </div>
      <div className={css.mappingActions}>
        <button
          className={css.btnPrimary}
          onClick={() => setImportStep(3)}
          data-testid="tt-import-preview-button"
        >
          Go to preview
        </button>
      </div>
    </div>
  );
}
